// extracted by mini-css-extract-plugin
export default {"fullscreen":"HmwH07rg","desktop":"desktop","mobile":"mobile","image":"gYZgOyJU","caption":"yvX4hYZj","captionHidden":"QIx_EbOW","icon":"c5euKgUM"};